export const Resultcontent = [
  {
    id: 0,
    rating: "4.44(192)",
    img: "./card_1.jpg",
    styles: "bigcontents__list1",
    title: "Sanitized 1 Bedroom",
    type: "Entire apartment",
    location: "New York",
    host: "Mike",
    amenities: "Wifi · Air condition · kitchen",
    smalldescription: "3 guests · 1 bedroom · 1 bed · 1 bath",
    price: "$100",
    description:
      "Massive 2 bedroom apartment literally SECONDS from Times Square. Comfortable, spacious and well maintained. Two full size bedrooms, separate kitchen, living room, office space. Stainless steel appliances, dishwasher. ",
  },
  {
    id: 1,
    img: "./card_2.jpg",
    rating: "4.75(102)",
    title: "Spacious 2 Bedroom.",
    type: "Entire apartment",
    location: "New Jersey",
    host: "Abod",
    amenities: "Wifi · Washer · kitchen",
    smalldescription: "4 guests · 2 bedrooms · 0 beds · 1 bath",
    price: "$150",
    description:
      "This modern one bedroom apartment is found in a luxury apartment building, located in the eclectic neighborhood of Chelsea. Must see attractions include The High Line and Chelsea Market. Step outside and get around the city with ease with access to the A, C and E trains, located at the 34th Street and 8th Avenue subway station and the 1, 2 and 3 trains found at the 34th Street and 7th Avenue subway station.",
  },
  {
    id: 2,
    img: "./result-card_3.jpg",
    rating: "New",
    title: "Furnished luxury rooms!",
    type: "Private room",
    location: "Florida",
    host: "Micheal",
    amenities: "Wifi · Washer · kitchen",
    smalldescription: "1 guest · 1 bedroom · 1 bed · 1 shared bath",
    price: "$80",
    description:
      "Rooms in apartment located in luxury building for rent. Seeking primarily young professionals/ students/ interns. Enjoy a beautiful and safe home with a young environment.",
  },
  {
    id: 3,
    img: "./card_4.jpg",
    rating: "4.15(35)",
    title: "Luxury King Room & Suit",
    type: "hotel Room",
    location: "New Jersey",
    host: "Abod Mike",
    amenities: "Wifi · Washer · iron",
    smalldescription: "2 guests · 1 bedroom · 1 bed · 1 private bath",
    price: "$92",
    description:
      "Appointed with sleek furniture, our classic rooms offer the traditional comforts of home in one of the most time-honored hotels in Texas. Our ADA rooms provide you with a spacious bathroom that contains a bath tub with grab bars, and multiple room configurations to choose for your stay with up to 270 square feet and a queen sized bed.",
  },
  {
    id: 4,
    img: "./result-card_5.jpg",
    rating: "3.75(162)",
    title: "Midtown One Bedroom ",
    type: "Entire apartment",
    location: "New York",
    host: "Toju",
    amenities: "Wifi · Washer · kitchen",
    smalldescription: "3 guests · 1 bedroom · 1 bed · 1 bath",
    price: "$169",
    description:
      "This modern one bedroom apartment is found in a luxury apartment building, located near the lively Theater District. This area is a tourist’s paradise, as it home to areas such as Times Square, Radio City Music Hall and Rockefeller Center. Step outside and get around the city with ease, as the 1 train is easily accessible from the 50th Street and Broadway subway station.",
  },
  {
    id: 5,
    img: "./card_3.jpg",
    rating: "4.55(155)",
    title: "PT Square Studio",
    type: "Entire apartment",
    location: "chicago",
    host: "abod micheal",
    amenities: "Wifi · Washer · kitchen",
    smalldescription: "2 guests · 1 bedroom · 0 beds · 1 bath",
    price: "$80",
    description:
      "Prime Times square location with access to restaurants & bars.",
  },
  {
    id: 6,
    img: "./result-card_7.jpg",
    rating: "4.25(425)",
    title: "Between TS & T District",
    type: "Room in hotel",
    location: "New Jersey",
    host: "Mike Abod",
    amenities: "Wifi · Washer · kitchen",
    smalldescription: "2 guests · 1 bedroom · 1 bed · 1 bath",
    price: "$109",
    description:
      "Setting a new standard in cozy chic, these Broadway Classic rooms come with one full-size bed and features private bathroom, 43-inch flat screen TV, WiFi access, in-room safe, designer amenities, and Egyptian cotton sheets.",
  },
  {
    id: 7,
    img: "./result-card_8.jpg",
    rating: "4.44(444)",
    title: "Two Bedded Suite",
    type: "hotel Room",
    location: "Washignton",
    host: "Abod",
    amenities: "Wifi · Washer · iron",
    smalldescription: "4 guests · 1 bedroom · 2 beds · 1 private bath",
    price: "$105",
    description:
      "Extra spacious with modern styling, our open layout studio suite features two beds, a lounge area with a small kitchen, flat screen TV, work space and iHome docking station. Can accommodate up to 4 guests Features lowered shelving and lowered door viewers and latches. Accessible bathrooms include bathtubs with handrails.",
  },
];

export const Maincontents = [
  {
    id: 8,
    img: "./handyman.jpg",
    title: "Handyman",
    description: "Squeaky door? Running toilet? ",
  },
  {
    id: 9,
    img: "./electrical2.jpg",
    title: "Electrician",
    description:
      "Unique activities we can do together, led by a world of hosts.",
  },
  {
    id: 10,
    img: "./painting3.jpg",
    title: "Painter",
    description: "Comfortable private places, with room for friends or family.",
  },
  {
    id: 10,
    img: "./roofer.jpg",
    title: "Roofer",
    description: "Comfortable private places, with room for friends or family.",
  },
];

export const Bigcontents = [
  {
    id: 11,
    img: "./main-card_1.jpg",
    styles: "bigcontents__list1",
    description: "Decode the science of 2020 with Bill Nye",
  },
  {
    id: 12,
    img: "./main-card_2.jpg",
    description: "Go on a leopard safari in Sri Lanka ",
  },
  {
    id: 13,
    img: "./main-card_3.jpg",
    styles: "bigcontents__list3",
    description: "Discover Buenos Aires street art and sketch",
  },
];

export const Content = [
  {
    id: 0,
    img: "./card_1.jpg",
    styles: "bigcontents__list1",
    title: "Bedroom  ",
    price: "$100/night",
    description: "Awesome residential streets just a few blocks from dining",
  },
  {
    id: 1,
    img: "./card_2.jpg",
    title: "full Home",
    price: "$150/night",
    description: "Hello Welcome to NJ. Here is a vibrating neighborhood ",
  },
  {
    id: 5,
    img: "./card_3.jpg",
    title: "Square Studio",
    styles: "bigcontents__list3",
    price: "$190/night",
    description:
      "Hell's kitchen is THE center of the entire city. Some of the best",
  },
  {
    id: 3,
    img: "./card_4.jpg",
    styles: "bigcontents__list4",
    title: "Hotel Suit",
    price: "$92/night",
    description: "Our Texas hotel offers the traditional comforts of home ",
  },
];
